import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { type FC, Suspense, lazy } from "react";

const MyCareTeamPage = lazy(() => import("./MyCareTeamPage.tsx"));

const MyCareTeamPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MyCareTeamPage />
    </Suspense>
  );
};

export default MyCareTeamPageLazy;
